/**
 * Report answers pre-filled from the valuation request (valuer name, address, case number, …).
 * No browser dependencies: the MCP route pre-fills with it exactly as the report page does.
 */
export const getValuationRequestValues = valuation => {
  const valuationReportValues = {
    valuer: "name-of-valuer",
    securityAddress: "address",
    sellingAgent: "sales-agent",
    company: "company-name-address",
    valuationType: "valuation-type",
    customerName: "name-of-applicant",
    expectedMarketValue: "market-value",
    propertyCaseNumber: "mortgage-ref-number",
    eircode: "eir-code"
  };

  const valuationTypes = {
    FULL: "Full",
    FINAL: "Final",
    // TODO: confirm which type is correct for valuation request data
    SUBSEQUENT: "Subsequent",
    REVALUATION: "Subsequent"
  };

  return Object.keys(valuation).reduce((acc, key) => {
    if (valuation[key] && valuationReportValues[key]) {
      switch (key) {
        case "valuer":
          acc[
            valuationReportValues[key]
            ] = `${valuation[key].firstName} ${valuation[key].lastName}`;
          break;
        case "company":
          acc[valuationReportValues[key]] = valuation[key].name;
          break;
        case "valuationType":
          acc[valuationReportValues[key]] = valuationTypes[valuation[key]];
          break;
        case "expectedMarketValue":
          acc[valuationReportValues[key]] = `€${valuation[key]}`;
          break;
        default:
          acc[valuationReportValues[key]] = valuation[key];
      }
    }
    return acc;
  }, {});
};
